import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonDialog } from './Dialog.definition';
import { chameleonSvg } from '../Svg';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDialog({ prefix }), chameleonIconButton({ prefix }), chameleonSvg({ prefix }));
}
